var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._b({attrs:{"contain":"","max-width":_vm.maxWidth,"max-height":_vm.height,"src":_vm.computedSrc,"alt":_vm.$t(`logo.${_vm.prefix}`)},on:{"error":_vm.useDefault}},'v-img',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }